module.exports = __webpack_public_path__ + "static/media/anna-norman.46b3df72.jpg";